/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchLiveScoreResponse
 */
export interface MatchLiveScoreResponse {
    /**
     * Running auto-scored total for participant1 (sum of its members' accumulated points).
     * @type {number}
     * @memberof MatchLiveScoreResponse
     */
    team1Score: number;
    /**
     * Running auto-scored total for participant2.
     * @type {number}
     * @memberof MatchLiveScoreResponse
     */
    team2Score: number;
    /**
     * First-to-X target that ends the match (METRIC_THRESHOLD templates only).
     * @type {number}
     * @memberof MatchLiveScoreResponse
     */
    targetValue?: number;
    /**
     * Epoch ms when scoring stops (TIME_BASED templates only).
     * @type {number}
     * @memberof MatchLiveScoreResponse
     */
    scoringEndsAt?: number;
    /**
     * Epoch ms of the last counted scoring event; 0 when nothing has scored yet.
     * @type {number}
     * @memberof MatchLiveScoreResponse
     */
    updatedAt: number;
}

/**
 * Check if a given object implements the MatchLiveScoreResponse interface.
 */
export function instanceOfMatchLiveScoreResponse(value: object): value is MatchLiveScoreResponse {
    if (!('team1Score' in value) || value['team1Score'] === undefined) return false;
    if (!('team2Score' in value) || value['team2Score'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function MatchLiveScoreResponseFromJSON(json: any): MatchLiveScoreResponse {
    return MatchLiveScoreResponseFromJSONTyped(json, false);
}

export function MatchLiveScoreResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchLiveScoreResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team1Score': json['team1Score'],
        'team2Score': json['team2Score'],
        'targetValue': json['targetValue'] == null ? undefined : json['targetValue'],
        'scoringEndsAt': json['scoringEndsAt'] == null ? undefined : json['scoringEndsAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function MatchLiveScoreResponseToJSON(json: any): MatchLiveScoreResponse {
    return MatchLiveScoreResponseToJSONTyped(json, false);
}

export function MatchLiveScoreResponseToJSONTyped(value?: MatchLiveScoreResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team1Score': value['team1Score'],
        'team2Score': value['team2Score'],
        'targetValue': value['targetValue'],
        'scoringEndsAt': value['scoringEndsAt'],
        'updatedAt': value['updatedAt'],
    };
}

